import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  Paper,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSignUpStyles } from '../../../../pages/get-started';
import { useQuestionsStyles } from './DescribeQuestion';
import CustomTextField from '../../../components/onboarding/CustomTextField';
import { useRouter } from 'next/router';
import { useOnboardingStyles } from '../../onboarding/OnboardingDesignWrapper';
import {
  COMPONENT_NAMES,
  SCREEN_NAMES,
  segmentEventApi,
  setUserAttribute,
  trackAnalyticsEvent,
} from '../../../constants/analyticsMeta';
import axios from 'axios';
import { CONTENT_AI_USER_TYPE } from '../../../constants/common';
import { useSession } from '../../../utility/services/customHooks';
import auth0 from 'auth0-js';
import { signOut } from '../../../utility/services/authActions';
import { isCorporateAndValidEmail } from '../../../utility/validation/email';
import ThreeBarLoader from '../../shared/ThreeBarLoader';
import QuattrLoader from '../../shared/QuattrLoader';
import Cookies from 'js-cookie';
import { setCookie } from './tools-common';

const FreeToolsOnboarding = ({
  toolMeta,
  isQwaDashboard = false,
  isCookiePresent = false,
  handleCloseSignUp = (abc) => {},
}) => {
  const signupStyles = useSignUpStyles();
  const questionStyles = useQuestionsStyles();
  const onboardingStyles = useOnboardingStyles();

  const { session } = useSession();
  const router = useRouter();
  const classes = useSignUpStyles();

  let qttr_tools_auth = Cookies.get('qttr_tools_auth');
  let clicked_skip_freeTools_signIn = Cookies.get('clicked_skip_freeTools_signIn');

  const [toolsAuth, setToolsAuth] = useState(qttr_tools_auth || '');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [checkboxError, setCheckboxError] = useState('');
  const [checked, setChecked] = useState(false);
  const [showCodeInput, setShowCodeInput] = useState(false);
  const [isSkippedSinIn, setIsSkippedSinIn] = useState(false);
  const [showPasswordSetScreen, setShowPasswordSetScreen] = useState(false);
  const [receiveEmailsChecked, setReceiveEmailsChecked] = useState(false);
  const [error, setError] = useState<{
    email?: boolean;
    firstName?: boolean;
    lastName?: boolean;
    code?: boolean;
    password?: boolean;
    password2?: boolean;
  }>({});
  const [errorMessage, setErrorMessage] = useState<{
    email?: string;
    firstName?: string;
    lastName?: string;
    code?: string;
    password?: string;
    password2?: string;
  }>({});
  const [passwordError, setPasswordError] = useState<string[]>([]);
  const [showRequestLoader, setShowRequestLoader] = useState(false);
  const [showVerifyLoader, setShowVerifyLoader] = useState(false);
  const [createAccountLoading, setCreateAccountLoading] = useState(false);
  const [redirectLoading, setRedirectLoading] = useState(false);
  const [userExists, setUserExists] = useState(false);
  const [isDisposable, setIsDisposable] = useState(false);
  const [isIframeLoading, setIsIframeLoading] = useState(false);
  const [googleSignUpLoader, setGoogleSignUpLoader] = useState(false);

  useEffect(() => {
    if (showCodeInput && email) {
      checkIfEmailIsDisposable(email);
    }
  }, [email, showCodeInput]);

  const setScreenIfUserExist = async () => {
    setIsIframeLoading(true);
    try {
      const result = await axios.post('/api/join-content-ai/user-validations-api');
      if (result?.data?.isExistingUser && !session?.user?.email) {
        setUserExists(true);
        if (window?.analytics) {
          window.analytics.track(`User Already Exists`, {
            option: `User Already Exists`,
            email: email,
            isQwaDashboard: false,
          });
        } else {
          segmentEventApi(
            `User Already Exists`,
            {
              option: `User Already Exists`,
              email: email,
              isQwaDashboard: false,
            },
            'track'
          );
        }
      } else {
        if (window?.analytics) {
          window.analytics.track(`Shown Create Account Screen`, {
            option: `Shown Create Account Screen`,
            email: email,
            isQwaDashboard: false,
            description: 'Cookie exist but user has not created account yet.',
          });
        } else {
          segmentEventApi(
            `Shown Create Account Screen`,
            {
              option: `Shown Create Account Screen`,
              email: email,
              isQwaDashboard: false,
              description: 'Cookie exist but user has not created account yet.',
            },
            'track'
          );
        }
      }
    } catch (error) {
      console.error('setScreenError');
      setUserExists(false);
    } finally {
      setIsIframeLoading(false);
    }
  };

  const preFillCookieParams = () => {
    if (qttr_tools_auth) {
      const [headerEncoded, payloadEncoded, signatureEncoded] = qttr_tools_auth.split('.');

      // Decode the base64-encoded payload
      const payload = JSON.parse(atob(payloadEncoded));
      if (payload?.email) {
        setEmail(payload.email);
      }
      if (payload?.firstName) {
        setFirstName(payload.firstName);
      }
      if (payload?.lastName) {
        setLastName(payload.lastName);
      }
      return payload?.email || null;
    }
    return null;
  };

  useEffect(() => {
    if (toolsAuth && isCookiePresent && qttr_tools_auth && !session?.user?.email && !isQwaDashboard) {
      const mailAddress = preFillCookieParams();
      // setScreenIfUserExist(mailAddress);
      setScreenIfUserExist();
    } else if (session?.user?.email) {
      setIsIframeLoading(true);
    }
  }, [toolsAuth, isCookiePresent, qttr_tools_auth, session?.user?.email]);

  const checkIfEmailIsDisposable = (email) => {
    setIsIframeLoading(true);
    return email
      ? axios
          .get(`https://disposable.debounce.io/?email=${email}`)
          .then((res) => setIsDisposable(res.data.disposable === 'true'))
          .catch(() => setIsDisposable(false))
          .finally(() => setIsIframeLoading(false))
      : (setIsDisposable(false), setIsIframeLoading(false));
  };

  const verifyOtp = async () => {
    const newError = { ...error };
    const newErrorMessage = { ...errorMessage };
    try {
      if (!code) {
        newErrorMessage.code = '* Required';
        newError.code = true;
      } else {
        newErrorMessage.code = '';
        newError.code = false;
      }
      setShowVerifyLoader(true);
      const res = await axios.post(
        '/api/join-content-ai/verify-otp',
        {
          email,
          otp: code,
          firstName,
          lastName,
          fullName: `${firstName} ${lastName}`,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (res?.data?.isExistingUser === true) {
        setShowCodeInput(false);
        setShowPasswordSetScreen(false);
        setUserExists(true);
        if (window?.analytics) {
          window.analytics.track(`User Already Exists`, {
            option: `User Already Exists`,
            email: email,
            isQwaDashboard: false,
          });
        } else {
          segmentEventApi(
            `User Already Exists`,
            {
              option: `User Already Exists`,
              email: email,
              isQwaDashboard: false,
            },
            'track'
          );
        }
      } else {
        setShowCodeInput(false);
        setShowPasswordSetScreen(true);
      }

      trackAnalyticsEvent({
        eventName: 'Verified Email with OTP',
        payload: {
          label: 'Verified Email with OTP',
          component_name: COMPONENT_NAMES.contentai_ai_tools,
          screen_name: SCREEN_NAMES.contentai_ai_tools,
          ...toolMeta,
        },
      });
      setUserAttribute('last_verified_at', new Date().toISOString());
      setUserAttribute('email_verified_with', 'Manual');
    } catch (error) {
      console.error('error : verifyOtp');
      newErrorMessage.code = 'Invalid OTP';
      newError.code = true;
    } finally {
      setShowVerifyLoader(false);
    }
    setErrorMessage(newErrorMessage);
    setError(newError);
  };

  const handleSubmitAndVerify = async () => {
    let allValid = true; // Flag to track if all validations pass
    const newError = { ...error };
    const newErrorMessage = { ...errorMessage };
    try {
      setShowRequestLoader(true);
      if (!email) {
        newErrorMessage.email = '* Required';
        newError.email = true;
        allValid = false;
      } else if (
        !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          email
        )
      ) {
        newErrorMessage.email = 'invalid Email';
        newError.email = true;
        allValid = false;
      } else {
        newErrorMessage.email = '';
        newError.email = false;
      }
      if (!firstName) {
        newErrorMessage.firstName = '* Required';
        newError.firstName = true;
      } else {
        newErrorMessage.firstName = '';
        newError.firstName = false;
      }

      if (!lastName) {
        newErrorMessage.lastName = '* Required';
        newError.lastName = true;
      } else {
        newErrorMessage.lastName = '';
        newError.lastName = false;
      }

      if (!checked) {
        setCheckboxError(' Please indicate that you have read and agree to the Terms of Use and Privacy Policy!');
      }

      allValid = allValid && !newError.firstName && !newError.lastName && checked;
      if (allValid) {
        trackAnalyticsEvent({
          eventName: 'Clicked - Submit & Get Code to Verify OR Resend code',
          payload: {
            label: 'Clicked - Submit & Get Code to Verify OR Resend code',
            firstName,
            lastName,
            email,
            recieve_marketing_emails: receiveEmailsChecked,
            component_name: COMPONENT_NAMES.contentai_ai_tools,
            screen_name: SCREEN_NAMES.contentai_ai_tools,
            ...toolMeta,
          },
        });
        await axios.post(
          '/api/join-content-ai/request-otp',
          {
            email,
            fullName: `${firstName} ${lastName}`,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        setShowCodeInput(true);
        trackAnalyticsEvent({
          eventName: 'Shown OTP Input field',
          payload: {
            label: 'Shown OTP Input field',
            firstName,
            lastName,
            email,
          },
        });
        if (window && window.analytics) {
          window.analytics.identify(email, {
            email: email,
            name: `${firstName} ${lastName}`,
            schema: '',
            instance_type: 'Content AI',
            user_type: session?.user?.userType ?? CONTENT_AI_USER_TYPE,
            company_name: '',
          });
        }
        setUserAttribute('firstName', firstName);
        setUserAttribute('lastName', lastName);
        setUserAttribute('email', email);
        setUserAttribute('recieve_marketing_emails', receiveEmailsChecked);
      }
    } catch (error) {
      console.error('error : handleSubmitAndVerify');
    } finally {
      setShowRequestLoader(false);
    }
    setErrorMessage(newErrorMessage);
    setError(newError);
  };

  const validatePassword = (password: string, password2: string): boolean => {
    // Regular expressions for password rules
    const lengthRegex = /.{8,}/;
    const uppercaseRegex = /[A-Z]/;
    const lowercaseRegex = /[a-z]/;
    const digitRegex = /\d/;
    const specialCharRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

    // Error messages
    let errors: string[] = [];

    // Check if passwords match
    if (!password || !password2) {
      errors.push("Password fields can't be empty");
    } else if (password !== password2) {
      errors.push('Passwords provided do not match');
    }
    // Check password rules
    else if (!lengthRegex.test(password)) {
      errors.push('Should contain at least 8 characters');
    } else if (!uppercaseRegex.test(password)) {
      errors.push('Should contain one capital case letter');
    } else if (!lowercaseRegex.test(password)) {
      errors.push('Should contain one small case letter');
    } else if (!digitRegex.test(password)) {
      errors.push('Should contain one numerical digit');
    } else if (!specialCharRegex.test(password)) {
      errors.push('Should contain one special character');
    }
    setPasswordError(errors);
    return errors?.length === 0;
  };

  const handlePasswordSet = async () => {
    setCreateAccountLoading(true);
    const isValid = validatePassword(password, password2);
    if (window?.analytics) {
      window.analytics.track('Clicked on Create Account', {
        option: 'Clicked on Create Account',
        isValidPassword: isValid,
        isQwaDashboard: false,
      });
    } else {
      segmentEventApi(
        'Clicked on Create Account',
        {
          option: 'Clicked on Create Account',
          isValidPassword: isValid,
          isQwaDashboard: false,
        },
        'track'
      );
    }

    if (isValid) {
      try {
        let payload = {
          email: email,
          firstName: firstName,
          lastName: lastName,
          password: password,
        };

        const config = {
          method: 'POST',
          url: `/api/join-content-ai/setup-free-tools-user`,
          data: payload,
        };
        const response = await axios.request(config);
        if (response?.data?.data?.created_at) {
          setRedirectLoading(true);
          const payload = {
            email: email || '',
            password: password || '',
          };
          sessionStorage.setItem(`freeToolsAuth`, btoa(JSON.stringify(payload)));
          if (window?.analytics) {
            window.analytics.track(`Created Account`, {
              option: `Created Account`,
              email: email,
              isQwaDashboard: false,
            });
          } else {
            segmentEventApi(
              `Created Account`,
              {
                option: `Created Account`,
                email: email,
                isQwaDashboard: false,
              },
              'track'
            );
          }
          if (window) {
            window.parent.postMessage(
              { action: 'redirectURL', url: `${process.env.NEXT_PUBLIC_HOST_URL}/user-verify` },
              '*'
            );
          } else {
            router.push(`${process.env.NEXT_PUBLIC_HOST_URL}/user-verify`);
          }
        } else {
          setUserExists(true);
          console.error('User Already Exists !');
          if (window?.analytics) {
            window.analytics.track(`User Already Exists`, {
              option: `User Already Exists`,
              email: email,
              isQwaDashboard: false,
            });
          } else {
            segmentEventApi(
              `User Already Exists`,
              {
                option: `User Already Exists`,
                email: email,
                isQwaDashboard: false,
              },
              'track'
            );
          }
          setCreateAccountLoading(false);
          router.push('/login');
        }
      } catch (error) {
        setCreateAccountLoading(false);
        console.error('Error: creating new user ');
      }
    } else {
      setCreateAccountLoading(false);
      trackAnalyticsEvent({
        eventName: 'Password Validation Error',
        payload: {
          label: 'Password Validation Error',
          email,
        },
      });
    }
  };

  return (
    <div className="free-tools-onboarding-wrapper">
      {redirectLoading ? (
        <>
          <QuattrLoader />
          <div className={signupStyles.grayedOutContainer}>
            <p className="free-tools-onboarding-header m-0">Account Created Successfully!</p>
            <p className="free-tools-onboarding-subheader m-0">
              You will be redirected to the Quattr platform shortly where you can continue enjoying the AI tools
              experience.
            </p>
          </div>
        </>
      ) : isIframeLoading ? (
        <>
          <ThreeBarLoader />
        </>
      ) : userExists ? (
        <>
          {' '}
          <Paper className={`${classes.signUpCard} ${classes.hideCreditCardMessage}`}>
            <Typography variant="h5" component="h2" className={onboardingStyles.heading}>
              You have an account with Quattr!
            </Typography>
            {email ? (
              <>
                <br />

                <b style={{ color: '#51D497', paddingTop: '30px', fontSize: '12px' }}>{email}</b>

                <Typography className={classes.alreadyExistHeading}>
                  {' '}
                  <b>
                    Looks like this email address has a Quattr account. <br /> Login to continue
                  </b>
                </Typography>
              </>
            ) : null}

            <br />

            <Button
              fullWidth
              variant="contained"
              disabled={createAccountLoading}
              color="primary"
              className={`${classes.signUpButton} ${classes.dynamicWidthBtn}`}
              onClick={() => {
                if (window.analytics) {
                  window.analytics.track(`Clicked On Retry Login`, {
                    option: `Clicked On Retry Login`,
                    isQwaDashboard: false,
                    current_page: '/get-started',
                    reason: 'Account Already Exist',
                  });
                } else {
                  segmentEventApi(
                    `Clicked On Retry Login`,
                    {
                      option: `Auto Login Error`,
                      isQwaDashboard: false,
                      current_page: '/get-started',
                      reason: 'Account Already Exist',
                    },
                    'track'
                  );
                }
                if (window) {
                  window.parent.postMessage({ action: 'redirectURL', url: '/login' }, '*');
                } else {
                  router.push('login');
                }
              }}
            >
              Login
            </Button>
            {/* <Typography variant="caption" className={classes.signUpSubHeading}>
              Want to create new account? <br />
              <span
                style={{ color: '#51D497', cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => {
                  if (window.analytics) {
                    window.analytics.track(`Clicked On Choose a Different Email`, {
                      option: `Clicked On Retry Login`,
                      isQwaDashboard: false,
                      path: '/free-tools',
                      reason: 'Account Already Exist',
                    });
                  } else {
                    segmentEventApi(
                      `Clicked On Choose a Different Email`,
                      {
                        option: `Auto Login Error`,
                        isQwaDashboard: false,
                        path: '/free-tools',
                        reason: 'Account Already Exist',
                      },
                      'track'
                    );
                  }
                  setShowPasswordSetScreen(false);
                  setShowCodeInput(false);
                  setUserExists(false);
                }}
              >
                Change Email Address
              </span>
            </Typography> */}
          </Paper>
        </>
      ) : showPasswordSetScreen ? (
        <>
          <div>
            <p className="free-tools-onboarding-header m-0">Set Your Free Account Password</p>
            <p className="free-tools-onboarding-subheader m-0 mb-30">
              Use a corporate email to get 2X free credits every 8 hours
            </p>
          </div>
          <div className={signupStyles.grayedOutContainer}>
            <CustomTextField
              id="password"
              label="Set a new password"
              value={password}
              type="password"
              whiteBg
              error={error?.password}
              placeholder={'********'}
              errorMessage={errorMessage?.password}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setPassword(e.target.value);
              }}
            />
            <CustomTextField
              id="password2"
              label="Re-enter your new password"
              value={password2}
              type="password"
              whiteBg
              error={error?.password2}
              placeholder={'********'}
              errorMessage={errorMessage?.password2}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setPassword2(e.target.value);
              }}
            />
            <div className="password-errors-wrapper">
              {passwordError ? <Typography className="error-text">{passwordError}</Typography> : null}

              <Typography>Password must contain</Typography>
              <div className="password-set-instructions">
                <div>
                  <li>Atleast 8 characters</li>
                  <li>One capital case letter, one small case letter</li>
                </div>
                <div>
                  <li>One numerical digit</li>
                  <li>One special character</li>
                </div>
              </div>
            </div>
            <div className="complete-pmt-wrapper">
              <Button className="complete-pmt-btn" disabled={createAccountLoading} onClick={() => handlePasswordSet()}>
                {createAccountLoading ? <CircularProgress size={20} /> : 'Create Account'}
              </Button>
            </div>
          </div>
        </>
      ) : showCodeInput ? (
        <>
          <div>
            <p className="free-tools-onboarding-header m-0 mb-30">Verify Email & Create a Free Account</p>
          </div>
          <div className={showCodeInput ? questionStyles.questionsWrapperForTools : ''} style={{ maxWidth: 'unset' }}>
            <CustomTextField
              label="Enter Code"
              value={code}
              placeholder="000000"
              limitWidth
              whiteBg
              error={error?.code}
              isOtp
              errorMessage={errorMessage?.code}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setCode(e.target.value);
              }}
              isOnToolsVerify={showCodeInput ? true : false}
            />

            <div className="free-tools-code-verify-actions">
              <Button
                fullWidth
                variant="outlined"
                disabled={showRequestLoader}
                style={{
                  borderRadius: '4.2px',
                  border: '1px solid #1D3557',
                  fontWeight: 700,
                }}
                className="reset-btn"
                onClick={handleSubmitAndVerify}
              >
                {showRequestLoader ? (
                  <svg version="1.1" id="loader" style={{ fill: '#1D3557' }}>
                    <path id="one" d="M5,25H0V0h5V25z" />
                    <path id="two" d="M15,25h-5V0h5V25z" />
                    <path id="three" d="M25,25h-5V0h5V25z" />
                  </svg>
                ) : null}
                {showRequestLoader ? 'Please wait...' : 'Resend Code'}
              </Button>

              <Button
                fullWidth
                variant="contained"
                disabled={showVerifyLoader}
                className="verify-btn"
                onClick={() => {
                  trackAnalyticsEvent({
                    eventName: 'Clicked - Complete Verification',
                    payload: {
                      label: 'Clicked - Complete Verification',
                      email,
                    },
                  });
                  verifyOtp();
                }}
                style={{ fontWeight: 700 }}
              >
                {showVerifyLoader ? (
                  <svg version="1.1" id="loader" style={{ fill: '#1D3557' }}>
                    <path id="one" d="M5,25H0V0h5V25z" />
                    <path id="two" d="M15,25h-5V0h5V25z" />
                    <path id="three" d="M25,25h-5V0h5V25z" />
                  </svg>
                ) : null}
                {showVerifyLoader ? 'Please wait...' : 'Complete Verification'}
              </Button>
            </div>
            {!isCorporateAndValidEmail(email) || (isCorporateAndValidEmail(email) && isDisposable) ? (
              <p className="free-tools-onboarding-subheader m-0 mb-0 mt-25">
                Use a corporate email to get 2X free credits!{' '}
              </p>
            ) : null}
            <Typography
              className={`${questionStyles.updateEmailLink} m-15`}
              onClick={() => {
                setShowCodeInput(false);
                trackAnalyticsEvent({
                  eventName: 'Clicked - Update my email address',
                  payload: {
                    label: 'Clicked - Update my email address',
                  },
                });
              }}
            >
              {`<< `} <span style={{ textDecorationLine: 'underline' }}>{`Update my email address`}</span>
            </Typography>
          </div>
        </>
      ) : !isSkippedSinIn ? (
        <>
          <div>
            <p className="free-tools-onboarding-header m-0">Create a Free Account to Continue</p>
            <p className="free-tools-onboarding-subheader m-0 mb-30">
              Takes only a few seconds! Use a corporate email to get <br />
              2X free credits every 8 hours
            </p>
          </div>
          <div className={signupStyles.grayedOutContainer}>
            <p className="free-account-exist-text">
              Already have an AI tools account?{' '}
              <span
                className="free-account-exist-sub-text"
                onClick={() => {
                  if (window) {
                    trackAnalyticsEvent({
                      eventName: 'Clicked - Login',
                      payload: {
                        label: 'Clicked - Login',
                      },
                    });
                    window.parent.postMessage({ action: 'redirectURL', url: '/login' }, '*');
                  } else {
                    trackAnalyticsEvent({
                      eventName: 'Clicked - Login',
                      payload: {
                        label: 'Clicked - Login',
                      },
                    });
                    router.push('/login');
                  }
                }}
              >
                Log in
              </span>
            </p>
            <div style={{ maxWidth: '500px' }}>
              <div>
                <Button
                  className={`${signupStyles.signUpWithGoogleForTools} ${signupStyles.signUpWithGoogle} mt-10`}
                  style={{ width: '280px', margin: 'auto', display: 'flex' }}
                  disabled={googleSignUpLoader}
                  onClick={() => {
                    setGoogleSignUpLoader(true);
                    trackAnalyticsEvent({
                      eventName: 'Clicked - Sign Up With Google',
                      payload: {
                        label: 'Clicked - Sign Up With Google',
                      },
                    });
                    if (window) {
                      trackAnalyticsEvent({
                        eventName: 'Redirected to Google Verify Screen',
                        payload: {
                          label: 'Redirected to Google Verify Screen',
                        },
                      });
                      window.parent.location.pathname = `/api/google-signup-for-new-free-tools-account`;
                    }
                  }}
                >
                  {googleSignUpLoader ? (
                    <ThreeBarLoader />
                  ) : (
                    <>
                      <svg
                        className={signupStyles.svgStyle}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M23.04 12.6777C23.04 11.8623 22.9668 11.0782 22.8309 10.3254H12V14.7738H18.1891C17.9225 16.2113 17.1123 17.4293 15.8943 18.2448V21.1302H19.6109C21.7855 19.1282 23.04 16.18 23.04 12.6777Z"
                          fill="#4285F4"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11.9999 23.9162C15.1049 23.9162 17.7081 22.8864 19.6108 21.1301L15.8943 18.2446C14.8645 18.9346 13.5472 19.3423 11.9999 19.3423C9.00471 19.3423 6.46948 17.3194 5.56516 14.6012H1.72311V17.5807C3.61539 21.3392 7.50448 23.9162 11.9999 23.9162Z"
                          fill="#34A853"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M5.56523 14.6015C5.33523 13.9115 5.20455 13.1745 5.20455 12.4165C5.20455 11.6585 5.33523 10.9215 5.56523 10.2315V7.25195H1.72318C0.944318 8.80445 0.5 10.5608 0.5 12.4165C0.5 14.2722 0.944318 16.0285 1.72318 17.581L5.56523 14.6015Z"
                          fill="#FBBC05"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11.9999 5.49025C13.6883 5.49025 15.2043 6.07047 16.3961 7.21002L19.6945 3.91161C17.7029 2.05593 15.0997 0.916382 11.9999 0.916382C7.50448 0.916382 3.61539 3.49343 1.72311 7.25184L5.56516 10.2314C6.46948 7.5132 9.00471 5.49025 11.9999 5.49025Z"
                          fill="#EA4335"
                        />
                      </svg>
                      Sign up with Google
                    </>
                  )}
                </Button>

                <Box className={signupStyles.dividerContainer} style={{ maxWidth: '350px', margin: '21px auto' }}>
                  <Divider className={signupStyles.divider} style={{ height: '0.5px' }} />
                  <Typography variant="caption" className={signupStyles.dividerText}>
                    Or, sign up with your email
                  </Typography>
                  <Divider className={signupStyles.divider} style={{ height: '0.5px' }} />
                </Box>
              </div>

              <>
                <div className={questionStyles.inputTextAlignment}>
                  <CustomTextField
                    label="First name"
                    value={firstName}
                    placeholder="John"
                    limitWidth
                    whiteBg
                    error={error?.firstName}
                    errorMessage={errorMessage?.firstName}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setFirstName(e.target.value);
                    }}
                  />
                  <CustomTextField
                    label="Last name"
                    value={lastName}
                    limitWidth
                    whiteBg
                    placeholder="Doe"
                    error={error?.lastName}
                    errorMessage={errorMessage?.lastName}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setLastName(e.target.value);
                    }}
                  />
                </div>
                <CustomTextField
                  label="Email address"
                  value={email}
                  type="email"
                  whiteBg
                  error={error?.email}
                  placeholder={'john.doe@quattr.com'}
                  errorMessage={errorMessage?.email}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setEmail(e.target.value);
                  }}
                />
              </>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    onChange={(event) => {
                      setCheckboxError('');
                      setChecked(event.target.checked);
                    }}
                    style={{ color: checked ? '#51D497' : undefined, paddingTop: '0px', paddingBottom: '0px' }}
                    className={`${checkboxError ? onboardingStyles.red : ''}`}
                  />
                }
                style={{ alignItems: 'center' }}
                label={
                  <div
                    className={` ${questionStyles.secondaryText} ${checkboxError ? onboardingStyles.red : ''}`}
                    style={{ fontSize: '12px' }}
                  >
                    <div>
                      I agree to Quattr’s{' '}
                      <a
                        className={`${checkboxError ? onboardingStyles.red : onboardingStyles.green} ${
                          onboardingStyles.link
                        }`}
                        href={'/content-ai/terms'}
                        onClick={(e) => {
                          e.preventDefault();
                          trackAnalyticsEvent({
                            eventName: 'Clicked - terms of service',
                            payload: {
                              label: 'Clicked - terms of service',
                            },
                          });
                          if (window) {
                            window.open('/content-ai/terms', '_blank');
                          } else {
                            router.push('/content-ai/terms');
                          }
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: '12px' }}
                      >
                        {' '}
                        terms of service
                      </a>{' '}
                      &amp;{' '}
                      <a
                        className={`${checkboxError ? onboardingStyles.red : onboardingStyles.green} ${
                          onboardingStyles.link
                        }`}
                        href={'/privacy-policy'}
                        onClick={(e) => {
                          e.preventDefault();
                          trackAnalyticsEvent({
                            eventName: 'Clicked - privacy policy',
                            payload: {
                              label: 'Clicked - privacy policy',
                            },
                          });
                          if (window) {
                            window.open('/privacy-policy', '_blank');
                          } else {
                            router.push('/privacy-policy');
                          }
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: '12px' }}
                      >
                        privacy policy
                      </a>
                      .
                    </div>
                  </div>
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={receiveEmailsChecked}
                    onChange={(event) => {
                      setReceiveEmailsChecked(event.target.checked);
                    }}
                    style={{
                      color: receiveEmailsChecked ? '#51D497' : undefined,
                      paddingTop: '0px',
                      paddingBottom: '0px',
                    }}
                  />
                }
                style={{ alignItems: 'center' }}
                label={
                  <div className={` ${questionStyles.secondaryText}`} style={{ fontSize: '12px' }}>
                    <div>I would like to receive marketing emails from Quattr.</div>
                  </div>
                }
              />
              <Button
                fullWidth
                variant="contained"
                color="primary"
                disabled={showRequestLoader}
                className={`${signupStyles.signUpButton} ${signupStyles.dynamicWidthBtn} ${signupStyles.largeCTA} `}
                onClick={handleSubmitAndVerify}
                style={{ textTransform: 'none' }}
              >
                {showRequestLoader ? (
                  <svg version="1.1" id="loader" style={{ fill: '#1D3557' }}>
                    <path id="one" d="M5,25H0V0h5V25z" />
                    <path id="two" d="M15,25h-5V0h5V25z" />
                    <path id="three" d="M25,25h-5V0h5V25z" />
                  </svg>
                ) : null}
                {showRequestLoader ? 'Please wait...' : 'Submit & Get Code to Verify'}
              </Button>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default FreeToolsOnboarding;
